import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IsEndFinEmailExistGQL } from "../../../../generated/graphql";
import { SnackBarService } from "../../service/snack.bar.service";
import { debounceTime } from "rxjs/operators";
@Component({
  selector: "add-contact-dialog",
  templateUrl: "add-contact-dialog.html",
})
export class AddContactDialog {
  contactForm: FormGroup;
  contact: any;
  contactList: any;
  countryCode: string;
  debounceTime: 500;

  constructor(
    public dialogRef: MatDialogRef<AddContactDialog>,
    private snackBarService: SnackBarService,
    private isEndFinEmailExistGQL: IsEndFinEmailExistGQL,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.contact = this.data?.contact;
    this.contactList = this.data?.contact_list;
    this.countryCode = this.data?.country_code;
    this.initFormControl();

    this.contactForm.controls.email.valueChanges
      .pipe(debounceTime(this.debounceTime))
      .subscribe((x) => {
        if (!this.contactForm.controls.email.invalid) {
          if (this.contact?.email?.toLowerCase().trim() != x.toLowerCase().trim()) {
            this.isEndFinEmailExistGQL
              .fetch({
                email: x,
              })
              .subscribe((result) => {
                if (result.data.isEndFinEmailExist)
                  this.contactForm.controls.email.setErrors({
                    used: true,
                  });
                else this.contactForm.controls.email.setErrors(null);
              });
          }
        }
        this.contactForm.controls.email.markAllAsTouched();
      });
  }

  private initFormControl() {
    this.contactForm = new FormGroup({
      id: new FormControl(null),
      name: new FormControl("", [Validators.required]),
      phoneNo: new FormControl("", [
        Validators.required,
        Validators.minLength(7)
      ]),
      email: new FormControl("", [Validators.required, Validators.email]),
    });

    if (this.contact && this.contactList) {
      this.contactList = this.contactList.filter(x => x.email !== this.contact.email);
      this.contactForm.controls.id.setValue(this.contact.id);
      this.contactForm.controls.name.setValue(this.contact.name);
      this.contactForm.controls.email.setValue(this.contact.email);
      this.contactForm.controls.phoneNo.setValue(this.contact.phoneNo);
    }

  }

  saveContact() {
    this.contactForm.markAllAsTouched();
    if (!this.contactForm.valid) {
      this.snackBarService.show("Please complete or correct the required field(s).");
      return;
    }
    let contact = this.contactForm.getRawValue();
    let existingContact = this.contactList ? this.contactList.find(x => x.email == contact.email) : null;
    if (existingContact) {
      this.snackBarService.show(
        "Contact email already added. Please use another email address.",
        null,
        { duration: 5000 }
      );
    } else {
      this.dialogRef.close(contact);
    }
  }

}
